import { render } from "./ProductForm.vue?vue&type=template&id=2621668b&scoped=true"
import script from "./ProductForm.vue?vue&type=script&lang=js"
export * from "./ProductForm.vue?vue&type=script&lang=js"

import "./ProductForm.vue?vue&type=style&index=0&id=2621668b&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2621668b"]])

export default __exports__